// extracted by mini-css-extract-plugin
export default {"button":"button_button__FjkXi","button__inner":"button_button__inner__Dvg09"};